export function buildHeader(config) {
  const header = document.createElement('div');

  if (config.title) {
    const titleText = document.createElement('h1');
    titleText.classList.add('title-text');
    titleText.innerText = config.title;
    header.appendChild(titleText);
  }

  if (config.logo) {
    const image = new Image();
    image.src = config.logo;
    header.appendChild(image);
  }

  if (config.subtitle) {
    const subtitleText = document.createElement('h2');
    subtitleText.innerText = config.subtitle;
    header.appendChild(subtitleText);
  }

  if (config.byline) {
    const bylineText = document.createElement('p');
    bylineText.innerText = config.byline;
    header.appendChild(bylineText);
  }

  if (config.info) {
    const infoContainer = document.createElement('span');
    infoContainer.setAttribute('id', 'info-container');
    infoContainer.innerText = 'ⓘ';
    infoContainer.title = 'Click for more information';

    const infoBox = document.createElement('div');
    infoBox.setAttribute('id', 'info-box');
    infoBox.innerText = config.info;
    infoBox.style.display = 'none';

    infoContainer.addEventListener('click', () => {
      infoBox.style.display = infoBox.style.display === 'none' ? 'block' : 'none';
    });

    header.appendChild(infoContainer);
    header.appendChild(infoBox);
  }

  if (config.bookmarks) {
    const bookmarksText = document.createElement('h5');
    bookmarksText.innerHTML = "<strong>Bookmarks</strong>: " +
      config.chapters
        .filter(ch => ch.title)
        .map(ch => `<a href="#${ch.id}">${ch.title}</a>`)
        .join(" | ");
    header.appendChild(bookmarksText);
  }

  if (config.mobileview) {
    const mobileText = document.createElement('p');
    mobileText.innerHTML = config.mobileview;
    header.appendChild(mobileText);
  }

  if (header.innerText.trim().length === 0) return null;

  header.classList.add(config.theme);
  header.id = 'header';
  return header;
}

